import { api } from './client';

export const clientsApi = {
  getAdminClients(filters: Record<string, string> = {}): Promise<{ clients: any[] }> {
    const params = new URLSearchParams(filters);
    return api.request<{ clients: any[] }>(`/admin/clients?${params}`);
  },

  getAdminClient(id: number | string): Promise<{ client: any }> {
    return api.request<{ client: any }>(`/admin/clients/${id}`);
  },
};